import topFilter from "./topFilter.service";

const topFilterTruckWheelService = {
  async fetchPossibleValues(params) {
    return topFilter.fetchPossibleValues('/catalog/api/truck/wheel/filter-preparation', params);
  },
  async searchProducts(params) {
    return topFilter.searchProducts('/catalog/api/truck/wheel/search', params);
  },
};

export default topFilterTruckWheelService;
